import FetchService from './fetch.service';
import localStorageService from './localStorage.service';

const fetchService = new FetchService();


class ConfigService {
    async getTagMonitorConfigData(companyId) {
        if (!companyId) companyId = localStorageService.getCompanyId();
        if (!companyId || isNaN(companyId)) {
            console.error('Invalid companyId for getTagMonitorConfigData:', companyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const response = fetchService(`/configurations/get_tag_monitor_configuration/${companyId}`, {
            method: 'GET',
            cache: 'no-cache',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }


    async getTagNames(companyId) {
        if (!companyId) companyId = localStorageService.getCompanyId();
        if (!companyId || isNaN(companyId)) {
            console.error('Invalid companyId for getTagNames:', companyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const response = fetchService(`/dashboard/get_tag_names/${companyId}/`, {
            method: 'GET',
            cache: 'no-cache',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }


    async getDomainNames(companyId) {
        if (!companyId) companyId = localStorageService.getCompanyId();
        if (!companyId || isNaN(companyId)) {
            console.error('Invalid companyId for getDomainNames:', companyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const response = fetchService(`/dashboard/get_domain_names/${companyId}/`, {
            method: 'GET',
            cache: 'no-cache',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }


    async getCloudRunMonitoringData(companyId) {
        if (!companyId) companyId = localStorageService.getCompanyId();
        if (!companyId || isNaN(companyId)) {
            console.error('Invalid companyId for getCloudRunMonitoringData:', companyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const response = fetchService(`/configurations/get_cloud_run_monitoring/${companyId}`, {
            method: 'GET',
            cache: 'no-cache',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }

    async getDataLayerGuardConfigData(companyId) {
        if (!companyId) companyId = localStorageService.getCompanyId();
        if (!companyId || isNaN(companyId)) {
            console.error('Invalid companyId for getDataLayerGuardConfigData:', companyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const response = fetchService(`/configurations/get_datalayer_guard_configuration/${companyId}`, {
            method: 'GET',
            cache: 'no-cache',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }
    
    async getSitespeedMonitorConfigData(companyId) {
        if (!companyId) companyId = localStorageService.getCompanyId();

        const response = fetchService(`/configurations/get_sitespeed_monitor_configuration/${companyId}`, {
            method: 'GET',
            cache: 'no-cache',
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }

    async saveDataLayerGuardConfigData(props) {
        const { configObj, companyId } = props;
        let finalCompanyId = companyId;
        if (!finalCompanyId) finalCompanyId = localStorageService.getCompanyId();
        if (!finalCompanyId || isNaN(finalCompanyId)) {
            console.error('Invalid companyId for saveDataLayerGuardConfigData:', finalCompanyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const normalizeOptionalValue = (value) => {
            if (typeof value !== 'string') return value;
            const normalized = value.trim().toLowerCase();
            if (normalized === 'none' || normalized === 'null' || normalized === 'undefined') {
                return '';
            }
            return value;
        };

        const sanitizedConfigObj = {
            ...configObj,
            slack_bot_token: normalizeOptionalValue(configObj?.slack_bot_token),
            slack_channel: normalizeOptionalValue(configObj?.slack_channel),
            teams_channel: normalizeOptionalValue(configObj?.teams_channel),
            teams_webhook: normalizeOptionalValue(configObj?.teams_webhook),
            slack_workspace_id: normalizeOptionalValue(configObj?.slack_workspace_id),
        };

        const response = fetchService(`/configurations/save_datalayer_guard_configuration/`, {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            body: JSON.stringify({
                company_id: finalCompanyId,
                config_data: sanitizedConfigObj,
            }),
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }

    async saveSitespeedMonitorConfigData(props) {
        const { configObj, companyId } = props;
        if (!companyId) companyId = localStorageService.getCompanyId();

        const response = fetchService(`/configurations/save_sitespeed_monitor_configuration/`, {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            body: JSON.stringify({
                company_id: companyId,
                config_data: configObj,
            }),
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }

    async saveTagMonitorConfigData(props) {
        const { configObj, companyId } = props;
        let finalCompanyId = companyId;
        if (!finalCompanyId) finalCompanyId = localStorageService.getCompanyId();
        if (!finalCompanyId || isNaN(finalCompanyId)) {
            console.error('Invalid companyId for saveTagMonitorConfigData:', finalCompanyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const response = fetchService(`/configurations/save_tag_monitor_configuration/`, {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            body: JSON.stringify({
                company_id: finalCompanyId,
                config_data: configObj,
            }),
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }

    async saveGoogleCloudData(props) {
        const { googleCloudDataForm, companyId } = props;
        let finalCompanyId = companyId;
        if (!finalCompanyId) finalCompanyId = localStorageService.getCompanyId();
        if (!finalCompanyId || isNaN(finalCompanyId)) {
            console.error('Invalid companyId for saveGoogleCloudData:', finalCompanyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const formData = new FormData();
        formData.append('company_id', finalCompanyId);
        formData.append('config_data', JSON.stringify(googleCloudDataForm));

        const fileData = googleCloudDataForm["upload"][0];
        if (fileData && fileData.originFileObj) {
            const file = fileData.originFileObj;
            formData.append('file', file);
        }

        const response = fetchService(`/configurations/setup_cloud_run/`, {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            body : formData,
            headers: {},
        });

        return response;
    }

    async updateCloudRunToggles(props) {
        const { companyId, cloud_run_monitoring, ss_error_monitoring } = props;
        let finalCompanyId = companyId;
        if (!finalCompanyId) finalCompanyId = localStorageService.getCompanyId();
        if (!finalCompanyId || isNaN(finalCompanyId)) {
            console.error('Invalid companyId for updateCloudRunToggles:', finalCompanyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const response = fetchService(`/configurations/update_cloud_run_toggles/`, {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            body: JSON.stringify({
                company_id: finalCompanyId,
                cloud_run_monitoring: cloud_run_monitoring,
                ss_error_monitoring: ss_error_monitoring,
            }),
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }

    async toggleCompanyActive(props) {
        const { companyId, active } = props;
        let finalCompanyId = companyId;
        if (!finalCompanyId) finalCompanyId = localStorageService.getCompanyId();
        if (!finalCompanyId || isNaN(finalCompanyId)) {
            console.error('Invalid companyId for toggleCompanyActive:', finalCompanyId);
            return Promise.reject(new Error('Invalid company ID'));
        }

        const response = fetchService(`/configurations/toggle_company_active/`, {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            body: JSON.stringify({
                company_id: finalCompanyId,
                active: active,
            }),
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
        });

        return response;
    }
}

export default new ConfigService();
